const emulatorScreen = (theme) => theme.breakpoints.down("1150")
const laptopScreen = (theme) => '@media (max-height: 900px)'
const mobileScreen = (theme) => {
  return '@media (max-width:900.95px) and (max-height:440px)'
}

export {
  emulatorScreen,
  laptopScreen,
  mobileScreen
}
